module.exports = __webpack_public_path__ + "static/media/from-pre-approved.6b350cfb.svg";